import { generateClient } from 'aws-amplify/api'
import { searchKnowledgeBase as searchKnowledgeBaseQuery } from '@/graphql/queries'
import { parseAwsJson } from '@/utils/graphql'
import { getApiMessage } from '@/mixins/Extras/ApiResponse'

const client = generateClient()

/** Raw semantic snippet search over an org's Knowledge Base content. */
export async function searchKnowledgeBase({ query, internalOrgId, contextId } = {}) {
  try {
    const { data, errors } = await client.graphql({
      query: searchKnowledgeBaseQuery,
      variables: {
        input: {
          query: String(query ?? '').trim(),
          internalOrgId: String(internalOrgId ?? '').trim(),
          ...(contextId ? { contextId: String(contextId) } : {}),
        },
      },
    })

    if (errors?.length) {
      throw new Error(errors[0].message)
    }

    return parseAwsJson(data?.searchKnowledgeBase)
  } catch (error) {
    return {
      status: 'ERROR',
      results: [],
      message: getApiMessage(error, 'Search failed'),
    }
  }
}
